import teamData from "../../data/pages/team.json";
import { buildSeoPageGraph } from "./pageGraph";
import { PATH_ABOUT } from "../../utils/constants";

type TeamMember = (typeof teamData.members)[number];

export const TEAM_MEMBERS = teamData.members;

export function buildTeamPageGraph() {
  const base = buildSeoPageGraph(PATH_ABOUT, "about", { includeFounder: true });
  const orgNode = base["@graph"].find(
    (node) => typeof node === "object" && node !== null && node["@type"] === "MedicalBusiness"
  ) as Record<string, unknown> | undefined;

  if (orgNode) {
    orgNode["@type"] = "MedicalOrganization";
    orgNode.employee = TEAM_MEMBERS.filter((member) => !member.isFounder).map((member: TeamMember) => ({
      "@type": "Person",
      name: member.name,
      jobTitle: member.jobTitle,
      description: member.description,
    }));
  }

  return base;
}
